import { Check, Copy } from 'lucide-react'
import { useState } from 'react'

import { useT } from '@/i18n'
import { cn } from '@/lib/cn'

/**
 * 一段只读、可一键复制的文本。
 *
 * 这些页面上的东西（manifest 地址、API key、配置 JSON）都是要被粘贴到
 * 别处去的，手动选中容易漏字符 —— 尤其是带换行的 JSON。
 */
export function CopyField({
  value,
  label,
  multiline = false,
}: {
  value: string
  label: string
  multiline?: boolean
}) {
  const t = useT()
  const [copied, setCopied] = useState(false)

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value)
      setCopied(true)
      setTimeout(() => setCopied(false), 1500)
    } catch {
      setCopied(false)
    }
  }

  return (
    <div className="relative">
      <pre
        className={cn(
          'overflow-x-auto rounded-md bg-surface-subtle p-3 pr-12 text-[13px]',
          multiline ? 'whitespace-pre' : 'whitespace-pre-wrap break-all',
        )}
      >
        {value}
      </pre>
      <button
        type="button"
        onClick={copy}
        aria-label={copied ? t('common.copied', { label }) : t('common.copy', { label })}
        className="absolute right-2 top-2 rounded-md p-2 text-ink-muted hover:bg-surface hover:text-ink"
      >
        {copied ? <Check className="size-4 text-brand-ink" /> : <Copy className="size-4" />}
      </button>
    </div>
  )
}
